import config from './all'
import au from './au'
import sg from './sg'
import jp from './jp'
import tw from './tw'
import us from './us'
import fr from './fr'
import it from './it'
import de from './de'
import es from './es'
import pl from './pl'
import ph from './ph'
import ie from './ie'

export default {
  config,
  au,
  sg,
  jp,
  tw,
  us,
  fr,
  it,
  de,
  es,
  pl,
  ph,
  ie
}